import { useState, useEffect } from "react";
import styles from "./Popup.module.css";
import { ConfirmEmailResetPasswordPopupProps } from "modules/register-login";
import ErrorFailed from "components/errorFailed/errorFailed";
import { checkEmail } from "services/userLogin/check-email";
import Popup from "components/Popup/popup";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { resetPasswordRequest } from "services/userLogin/reset-password-request";

export default function ConfirmEmailResetPasswordPopup({ isOpen, onClose }: ConfirmEmailResetPasswordPopupProps) {
    const [animationState, setAnimationState] = useState("popupExit");
    const [email, setEmail] = useState<string>("");
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (isOpen) {
            setAnimationState("popupEnter");
        } else {
            setAnimationState("popupExit");
            setEmail(""); 
        }
    }, [isOpen]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
    };

    const handleClose = () => {
        setAnimationState("popupExit");
        setEmail("");
        setError(null); 
        onClose();
    };

    const validateForm = async (): Promise<boolean> => {
        if (!email.trim()) { 
            setError("Die Email ist erforderlich.");
            return false;
        }

        try {
            const res = await checkEmail(email.trim());
            if (!res.exists || res.is_archived) {
                setError("Ungültige E-Mail.");
                return false;
            }
        } catch (error) {
            setError("Serverfehler. Bitte versuchen Sie es später noch einmal.");
            return false;
        }

        return true;
    };

    const handleSubmit = async () => {
        setError(null);

        const isValid = await validateForm();
        if (!isValid) return;

        try {
            const res = await resetPasswordRequest(email.trim());
            if (!res.success) {
                setError(res.message || "Ein Fehler ist aufgetreten.");
            } else {
                handleClose();
            }
        } catch (error) {
            setError("Ein Fehler ist aufgetreten. Bitte versuchen Sie es später.");
        }
    };

    if (!isOpen && animationState === "popupExit") return null;

    return (
        <Popup
            title={"Email bestätigen"}
            submitLabel={""}
            closeLabel={""}
            isWithButton={false}
            isOpen={isOpen}
            onClose={handleClose}
            onSubmit={() => { }}
        >
            {error && <ErrorFailed error={error} />}
            <div className={commonStyles.formGroup}>
                <label htmlFor="email">E-Mail</label>
                <input
                    type="email"
                    id="email"
                    name="email"
                    value={email}
                    onChange={handleChange}
                    required
                />
            </div>
            <div className={styles.popupButtonContainer}>
                <button
                    type="button"
                    className={`${commonStyles.commonButton} ${commonStyles.backButton}`}
                    onClick={handleClose}
                >
                    Abbrechen
                </button>
                <button
                    type="button"
                    className={`${commonStyles.commonButton} ${commonStyles.submitButton}`}
                    onClick={handleSubmit}
                >
                    Zurücksetzen
                </button>
            </div>
        </Popup>
    );
}
